import builder from './builder';
import dropzone from './dropzone';
import intakeForm from './intakeForm';
import saml from './saml';
import ticket from './ticket';
import ticketReviewer from './ticketReviewer';
import workflow from './workflow';

export default {
  builder,
  dropzone,
  intakeForm,
  saml,
  ticket,
  ticketReviewer,
  workflow,
};
